import { TranslatorFunction } from "i18n/util";
import { action, computed, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

class UiHelpers {
    TABLET_WIDTH = 600;
    TABLET_LANDSCAPE_WIDTH = 1000;

    // MUST not be an observable because authStore.locale already triggers the
    // rerender in App.tsx. So this would trigger a second rerender.
    __!: TranslatorFunction;
    resizeListenerAdded = false;
    @observable windowWidth = 0;
    @observable windowHeight = 0;
    @observable isPopupVisible = false;

    mediaQueryList: any;
    @observable isDarkMode = false;

    @observable snackbarProps?: {
        message: string;
        durationInMs: number;
        onClose: () => void;
    };

    @computed get isMobile() {
        return this.windowWidth && (this.windowWidth < this.TABLET_WIDTH);
    }

    @computed get isTabletPortrait() {
        return this.windowWidth && (this.windowWidth >= this.TABLET_WIDTH && this.windowWidth < this.TABLET_LANDSCAPE_WIDTH);
    }

    @computed get isTabletLandscape() {
        return this.windowWidth && (this.windowWidth >= this.TABLET_LANDSCAPE_WIDTH);
    }

    @computed get isDesktop() {
        return !this.isMobile;
    }

    onResize = () => {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName("body")[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;

        this.windowWidth = x;
        this.windowHeight = y;
    }

    /**
     * Add this in componentDidMount of your outmost container component
     */
    addResizeListener() {
        if (!this.resizeListenerAdded) {
            window.addEventListener("resize", this.onResize);
            this.onResize();
            this.resizeListenerAdded = true;
        }
    }

    changeDarkMode = () => {
        if (this.mediaQueryList.matches) {
            this.isDarkMode = true;
        } else {
            this.isDarkMode = false;
        }
    }

    addDarkModeListener() {
        if (window.matchMedia) {
            this.mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
            this.changeDarkMode();
            this.mediaQueryList.addListener(this.changeDarkMode);
        }

    }

    /**
     * Add this in componentWillUnmount of your outmost container component
     */
    removeResizeListener() {
        if (this.resizeListenerAdded) {
            window.addEventListener("resize", this.onResize);
            this.resizeListenerAdded = false;
        }
    }

    removeDarkModeListener() {
        if (this.mediaQueryList) {
            this.mediaQueryList.removeListener(this.changeDarkMode);
        }
    }

    @action showSnackbar = (message: string, durationInMs = 4000, onClose?: any) => {
        this.snackbarProps = {
            message: message,
            durationInMs: durationInMs,
            onClose: () => {
                this.snackbarProps = undefined;
                if (onClose) {
                    onClose();
                }
            }
        };
    }
}

export const ui = new UiHelpers();




// WEBPACK FOOTER //
// ./src/components/util/uiHelpers.tsx